import { UniversalHero } from 'components/UniversalHero/UniversalHero';
import * as React from 'react';
import Layout from 'layout/index';
import { PartnersSection } from 'sections/PartnersSection/PartnersSection';
import { getDisabledPages, getDynamicPages } from 'utils/utils';
import { NotFoundPageInfo } from 'sections/NotFoundPageInfo/NotFoundPageInfo';

interface PartnersPageProps {
    location: {
        pathname: string;
    };
    pageContext: any;
}

export default ({ pageContext, location }: PartnersPageProps) => {
    const partnersData =
        pageContext?.data?.wpInvestment?.investment?.partnersLogos;

    const pageTitle = `${pageContext?.title} - ${partnersData?.title}`;

    if (!pageContext?.data?.wpInvestment?.investment?.enablePartnersLogos) {
        return (
            <Layout
                displayPartnersPage={
                    pageContext?.data?.wpInvestment?.investment
                        ?.enablePartnersLogos
                }
                headerData={pageContext?.headerData}
                investmentSlug={pageContext?.slug}
                location={location}
                investmentDisabledPages={getDisabledPages(
                    pageContext?.data?.wpInvestment?.investment,
                )}
                investmentDynamicPages={getDynamicPages(
                    pageContext?.data?.wpInvestment?.investment,
                )}
            >
                <NotFoundPageInfo />
            </Layout>
        );
    }

    return (
        <Layout
            displayPartnersPage={
                pageContext?.data?.wpInvestment?.investment?.enablePartnersLogos
            }
            headerData={pageContext?.headerData}
            investmentSlug={pageContext?.slug}
            pageTitle={pageTitle}
            location={location}
            displayBanner
            investmentDisabledPages={getDisabledPages(
                pageContext?.data?.wpInvestment?.investment,
            )}
            investmentDynamicPages={getDynamicPages(
                pageContext?.data?.wpInvestment?.investment,
            )}
        >
            <>
                <UniversalHero
                    background={partnersData?.titleBackground?.sourceUrl}
                    text={partnersData?.description}
                    title={partnersData?.title}
                />
                <PartnersSection
                    pathname={location.pathname}
                    logos={partnersData?.logos}
                />
            </>
        </Layout>
    );
};
